export const ContentType = {
  JSON: 'application/json',
  UrlEncoded: 'application/x-www-form-urlencoded',
  Multipart: 'multipart/form-data'
};